export const dateTimeFormat = 'MM/DD/YYYY, hh:mm A';
